import React,{useEffect} from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })
    return (
        <div className="container mb-5">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-5">
                <ol className="breadcrumb">
                    {/* Home Link */}
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="fa-regular fa-folder me-2"></i> Privacy Policy
                    </li>
                </ol>
            </nav>

            <h1 style={{ textAlign: "left", marginBottom: "30px" }}>Privacy Policy</h1>

            <p>
                Online Shop Matrix (“we,” “our,” or “us”) values your privacy and is committed to protecting your personal information.
                This Privacy Policy explains how we collect, use, and safeguard your information when you visit our e-commerce platform.
            </p>

            <h2>1. Information We Collect</h2>
            <ul>
                <li><strong>Personal Information:</strong> Name, email address, phone number, billing and shipping addresses.</li>
                <li><strong>Payment Information:</strong> Credit/debit card details and billing information (processed securely through our payment partners).</li>
                <li><strong>Usage Data:</strong> Information on how you interact with our website, including pages visited, products viewed, and purchase history.</li>
                <li><strong>Cookies and Tracking Technologies:</strong> To enhance your shopping experience and provide personalized content.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <ul>
                <li>Process and fulfill orders.</li>
                <li>Communicate with you regarding your purchases, promotions, and updates.</li>
                <li>Improve our website, products, and services.</li>
                <li>Prevent fraudulent transactions and ensure security.</li>
                <li>Comply with legal obligations.</li>
            </ul>

            <h2>3. Sharing Your Information</h2>
            <p>
                We do not sell or rent your personal information. We may share your information with trusted third-party service providers who assist in:
            </p>
            <ul>
                <li>Payment processing.</li>
                <li>Shipping and delivery.</li>
                <li>Marketing and analytics services.</li>
            </ul>
            <p>These third parties are obligated to keep your information secure and use it only for specified purposes.</p>

            <h2>4. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
                <li>Access and correct your personal information.</li>
                <li>Request deletion of your personal information.</li>
                <li>Opt out of marketing communications.</li>
                <li>Withdraw consent where applicable.</li>
            </ul>

            <h2>5. Security of Your Information</h2>
            <p>
                We implement industry-standard security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction.
            </p>

            <h2>6. Cookies and Tracking</h2>
            <p>
                We use cookies and similar technologies to enhance your shopping experience, track user activity, and analyze trends. You may choose to disable cookies in your browser settings, but some features of the website may not function properly.
            </p>

            <h2>7. Third-Party Links</h2>
            <p>
                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites.
            </p>

            <h2>8. Children’s Privacy</h2>
            <p>
                Our services are not directed to individuals under 13 years of age. We do not knowingly collect personal information from children.
            </p>

            <h2>9. Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
            </p>

            <h2>10. Contact Us</h2>
            <p>
                Online Shop Matrix<br />
                2120 Camino Doce SW, Deming, New Mexico 88030, USA<br />
                Phone: +1 (574) 858-0288<br />
                Email: contact@onlineshopmatrix.com
            </p>
        </div>
    );
};

export default PrivacyPolicy;
